import {
  StatusResponse,
  TecnosException,
  TecnosMultiError,
} from '../../models';
import { ERRORS_FOR_ACTION, GENERIC_ERROR } from '../constants';
import { ApiResponse } from '@jobcost-monorepo/crud';

export function translateError(status: string | number): string {
  try {
    return ERRORS_FOR_ACTION[status] || GENERIC_ERROR;
  } catch (e) {
    return GENERIC_ERROR;
  }
}

function formatTecnosMultiError(
  error: TecnosMultiError,
  includeFieldNames = false,
): string {
  let errorString = '';
  error.detail.forEach((err, index) => {
    errorString +=
      (err.loc && err.loc[1] && includeFieldNames ? err.loc[1] + ': ' : '') +
      err.msg;
    index + 1 !== error.detail.length && (errorString += '\n');
  });
  return errorString;
}

export function handleError(
  status: string | number,
  statusResponse?: StatusResponse | TecnosException | TecnosMultiError,
  hideGlobalErrorModal?: boolean,
  includeFieldNamesOnDetail = false,
): any {
  try {
    if (status === 998) {
      //window.location.replace(`${window.location.origin}${MULTI_TAB}`);
      // TODO GESTIRE L'ERRORE MULTITAB (NON DOVREBBE IN TEORIA POTER SUCCEDERE)
      return;
    }

    if (status === 503) {
      window.addEventListener('submit', (event) => {
        event.preventDefault();
      });
      // TODO GESTIRE SE IL SITO E' IN MANUTENZIONE

      return;
    }

    // @ts-ignore
    let errorMessage;
    let errorCode;

    errorMessage = translateError(status);
    try {
      if (statusResponse) {
        if ('status' in statusResponse) {
          errorMessage = statusResponse.status?.message
            ? statusResponse.status?.message
            : translateError(status);
        } else if ('error' in statusResponse) {
          if (!statusResponse.message && !statusResponse.error) {
            errorMessage = translateError(status);
          } else {
            errorMessage = statusResponse.message || statusResponse.error;
            errorMessage += statusResponse.detail
              ? ' ' + statusResponse.detail
              : '';
          }
          errorCode = statusResponse.error_code;
        } else if ('detail' in statusResponse) {
          errorMessage = formatTecnosMultiError(
            statusResponse,
            includeFieldNamesOnDetail,
          );
        }
      }
    } catch (error: any) {
      errorMessage = GENERIC_ERROR;
    }
    return new Promise((resolve) => {
      const result: ApiResponse<any> = {
        data: undefined,
        succeeded: false,
        // @ts-ignore
        errors: errorMessage,
      };
      resolve(result);
    });
  } catch (error: any) {
    console.error('Error', status, { statusResponse }, { error });
  }
}
